import React from 'react'
import { GatsbyBrowser, Script } from 'gatsby'
import { Seo, SiteContainer } from './src/components'
import { Toaster } from './src/components/ui/sonner'
import './src/styles/index.css'

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
  props,
}) => (
  <>
    <Script data-termly-config>
      {`(window.TERMLY_CUSTOM_BLOCKING_MAP = {
          'datocms-assets.com': 'essential'
        })`}
    </Script>
    <Script
      src="https://app.termly.io/embed.min.js"
      data-auto-block="on"
      data-website-uuid="8ac21d78-7803-4ecd-a7b9-95a3b8c29005"
    />
    <Seo />
    <SiteContainer {...props}>{element}</SiteContainer>
  </>
)
